import { Ability } from '@/models/Ability';

// The CASL permission layer is intentionally kept although currently dormant
// (no route declares meta.permissions, no template uses $can). It is reserved
// for a planned moderation feature: temporarily/permanently disabling specific
// functions for specific users (e.g. revoking forum-posting from an abusive
// user). Do not remove it just because the maps below look near-empty.

interface Permissions {
  [key: string]: Ability[];
}

export default {
  rolePermissions: {
    ALL_USERS: [
      {
        action: 'use',
        subject: 'Platform',
      },
    ],
    USER_IN_REGISTRATION: [],
    USER_IN_APPROVAL: [],
    SYSTEM_USER: [],
  } as Permissions,

  additionalPermissions: {
    START_CONVERSATIONS: [
      {
        action: 'create',
        subject: 'VideoChat',
      },
    ],
  } as Permissions,
};
